export default "/images/vendor/flag-icons/flags/4x3/fk.svg?1c958169982971ccfe4ca2907a2c02f8";